import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { Admin, DashAdmin, Home, PrimaryLayout, TriviaAdmin } from 'containers'
import { AdminBetaSignupsRouter } from './BetaSignups'
import { AdminCategoriesRouter } from './Categories'
import { AdminDungeonRouter } from './Dungeons'
import { AdminFeatureFlagsRouter } from './FeatureFlags'
import { AdminNpcRouter } from './Npcs'
import { AdminQuestRouter } from './Quests'
import { AdminPlaceRouter } from './Places'
import { AdminRolesRouter } from './Roles'
import { AdminTagRouter } from './Tags'
import { AdminUserRouter } from './Users'

export const AdminRouter = () => {
  return (
    <Routes>
      <Route path="/*" element={<PrimaryLayout />}>
        <Route index element={<Admin />} />
        <Route path="games/dash/:id" element={<DashAdmin />} />
        <Route path="games/trivia/:id" element={<TriviaAdmin />} />
        <Route path="beta_signups/*" element={<AdminBetaSignupsRouter />} />
        <Route path="categories/*" element={<AdminCategoriesRouter />} />
        <Route path="dungeons/*" element={<AdminDungeonRouter />} />
        <Route path="feature_flags/*" element={<AdminFeatureFlagsRouter />} />
        <Route path="npcs/*" element={<AdminNpcRouter />} />
        <Route path="quests/*" element={<AdminQuestRouter />} />
        <Route path="places/*" element={<AdminPlaceRouter />} />
        <Route path="roles/*" element={<AdminRolesRouter />} />
        <Route path="tags/*" element={<AdminTagRouter />} />
        <Route path="users/*" element={<AdminUserRouter />} />
      </Route>
    </Routes>
  )
}
